import commonReducer from "./common/reducer";
import candidatesReducer from "./candidates/reducer";
import masterReducer from "./master/reducer";
import authReducer from "./auth/reducer";
import objectionTrackerReducer from "./objectionTracker/reducers";
import capcourseReducer from "./capcourse/reducers";
import objectionReducer from "./objection/reducer";

const reducers = {
    commonReducer,
    candidatesReducer,
    masterReducer,
    authReducer,
    objectionTrackerReducer,
    capcourseReducer,
    objectionReducer
};

export default reducers;